import { render, staticRenderFns } from "./FaxList.vue?vue&type=template&id=cf2ad180&"
import script from "./FaxList.vue?vue&type=script&lang=js&"
export * from "./FaxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports